// Generated by CoffeeScript 2.4.1
(function() {
  var ErrorCodes, Operation, Promise, Weaver, WeaverError, WeaverNode, WeaverRelationIn, _, cuid, util, uuid, wpath,
    indexOf = [].indexOf;

  cuid = require('cuid');

  uuid = require('uuid/v4');

  Promise = require('bluebird');

  _ = require('lodash');

  Operation = require('./Operation');

  Weaver = require('./Weaver');

  util = require('./util');

  wpath = require('./wpath');

  WeaverError = require('./Error');

  WeaverRelationIn = require('./WeaverRelationIn');

  ErrorCodes = require('./WeaverError');

  WeaverNode = class WeaverNode {
    static generateId() {
      var type;
      type = Weaver.identifierStyle;
      if (type === 'uuid') {
        return `${Weaver.identifierPrefix}${uuid()}`;
      } else {
        return `${Weaver.identifierPrefix}${cuid()}`;
      }
    }

    constructor(nodeId1, graph1, upsert) {
      var ref, ref1;
      this._destroy = this._destroy.bind(this);
      // Removes node, with the option to remove it unrecoverable
      this.destroy = this.destroy.bind(this);
      this.nodeId = nodeId1;
      this.graph = graph1;
      this.upsert = upsert;
      // Generate random id if not given
      if (this.nodeId == null) {
        this.nodeId = WeaverNode.generateId();
      }
      this._stored = false; // if true, available in database, local node can hold unsaved changes
      this._loaded = false; // if true, all information from the database was localised on construction
      // Store all attributes and relations in these objects
      this._attributes = {};
      this._relations = {};
      this._relationsIn = {};
      this.relationsIn = {}; // todo: deprecate this
      this._sets = []; // todo: deprecate this
      this._labels = [];
      // All operations that need to get saved
      this._pendingWrites = [Operation.Node(this).createNode(this.upsert)];
      this._createdAt = new Date().toISOString(); // Temporary value, will be set definetively server side
      this._createdBy = (ref = Weaver.instance) != null ? (ref1 = ref.currentUser()) != null ? ref1.id() : void 0 : void 0;
      Weaver.publish('node.created', this);
    }

    pendingWrites() {
      if (this._cache != null) {
        return this._cache._pendingWrites;
      } else {
        return this._pendingWrites;
      }
    }

    identityString() {
      return `${this.graph}:${this.nodeId}`;
    }

    // Node loading from server
    static async load(nodeId, params = {}) {
      var query;
      if (params.NodeClass == null) {
        params.NodeClass = WeaverNode;
      }
      if (params.includeRelations == null) {
        params.includeRelations = false;
      }
      if (params.includeAttributes == null) {
        params.includeAttributes = false;
      }
      query = new Weaver.Query();
      if (params.includeRelations) {
        query.withRelations();
      }
      if (params.includeAttributes) {
        query.withAttributes();
      }
      return (await query.get(nodeId, params));
    }

    static loadFromGraph(nodeId, graph, params = {}) {
      params.graph = graph;
      return this.load(nodeId, params);
    }

    static loadFromQuery(object, constructorFunction, fullyLoaded = true, model, excludeMap, filterFunction = function() {
        return true;
      }) {
      var Constructor, instance, ref, ref1;
      if (constructorFunction != null) {
        Constructor = constructorFunction(WeaverNode.loadFromQuery(object, void 0, void 0, model));
      }
      if (Constructor == null) {
        Constructor = model != null ? Weaver.DefinedNode : Weaver.Node;
      }
      if (object.isRelation) {
        Constructor = Weaver.RelationNode;
      }
      if (object.isAttribute) {
        Constructor = Weaver.AttributeNode;
      }
      instance = new Constructor(object.nodeId, object.graph, model);
      instance._loadFromQuery(object, constructorFunction, fullyLoaded, model, excludeMap, filterFunction);
      instance._setStored();
      if (instance instanceof Weaver.RelationNode) {
        if (object.relationSource != null) {
          instance.fromNode = WeaverNode.loadFromQuery(object.relationSource, void 0, false);
        }
        if (object.relationTarget != null) {
          instance.toNode = WeaverNode.loadFromQuery(object.relationTarget, void 0, false);
        }
        instance.key = object.relationKey;
      }
      if (instance instanceof Weaver.AttributeNode) {
        if (object.attributeSource != null) {
          instance.fromNode = WeaverNode.loadFromQuery(object.attributeSource, void 0, false);
        }
        if (object.attributeKey != null) {
          instance.key = object.attributeKey;
        }
        if (((ref = object.attributeValue) != null ? ref.value : void 0) != null) {
          instance.value = object.attributeValue.value;
        }
        if (((ref1 = object.attributeValue) != null ? ref1.dataType : void 0) != null) {
          instance.dataType = object.attributeValue.dataType;
        }
      }
      return instance;
    }

    _loadFromQuery(object, constructorFunction, fullyLoaded = true, model, excludeMap = {}, filterFunction) {
      var Constructor, attribute, attributes, instance, j, k, key, l, len, len1, len2, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, relation, relations;
      this._loaded = (object.creator != null) && fullyLoaded;
      this._createdAt = object.created;
      this._createdBy = object.creator;
      this._labels = object.labels;
      ref = object.attributes;
      for (key in ref) {
        attributes = ref[key];
        for (j = 0, len = attributes.length; j < len; j++) {
          attribute = attributes[j];
          if ((ref1 = excludeMap[attribute.graph]) != null ? ref1[attribute.nodeId] : void 0) {
            continue;
          }
          if (!filterFunction(attribute)) {
            continue;
          }
          this._loadAttributeFromQuery(key, attribute.value, attribute.dataType, attribute.nodeId, attribute.graph, attribute.created, attribute.creator);
        }
      }
      ref2 = object.relationsIn;
      for (key in ref2) {
        relations = ref2[key];
        for (k = 0, len1 = relations.length; k < len1; k++) {
          relation = relations[k];
          if ((ref3 = excludeMap[relation.graph]) != null ? ref3[relation.nodeId] : void 0) {
            continue;
          }
          if ((ref4 = excludeMap[relation.source.graph]) != null ? ref4[relation.source.nodeId] : void 0) {
            continue;
          }
          if (!filterFunction(relation)) {
            continue;
          }
          Constructor = void 0;
          if (constructorFunction != null) {
            Constructor = constructorFunction(WeaverNode.loadFromQuery(relation.source, void 0, void 0, model), this, key);
          }
          if (relation.source.isRelation) {
            Constructor = Weaver.RelationNode;
          }
          if (relation.source.isAttribute) {
            Constructor = Weaver.AttributeNode;
          }
          if (Constructor == null) {
            Constructor = model != null ? Weaver.DefinedNode : Weaver.Node;
          }
          instance = new Constructor(relation.source.nodeId, relation.source.graph, model);
          instance._loadFromQuery(relation.source, constructorFunction, fullyLoaded, model, excludeMap, filterFunction);
          this._loadRelationInFromQuery(key, instance, relation.nodeId, relation.graph, relation.created, relation.creator);
        }
      }
      ref5 = object.relations;
      for (key in ref5) {
        relations = ref5[key];
        for (l = 0, len2 = relations.length; l < len2; l++) {
          relation = relations[l];
          if ((ref6 = excludeMap[relation.graph]) != null ? ref6[relation.nodeId] : void 0) {
            continue;
          }
          if ((ref7 = excludeMap[relation.target.graph]) != null ? ref7[relation.target.nodeId] : void 0) {
            continue;
          }
          if (!filterFunction(relation)) {
            continue;
          }
          Constructor = void 0;
          if (constructorFunction != null) {
            Constructor = constructorFunction(WeaverNode.loadFromQuery(relation.target, void 0, void 0, model), this, key);
          }
          if (relation.target.isRelation) {
            Constructor = Weaver.RelationNode;
          }
          if (relation.target.isAttribute) {
            Constructor = Weaver.AttributeNode;
          }
          if (Constructor == null) {
            Constructor = model != null ? Weaver.DefinedNode : Weaver.Node;
          }
          instance = new Constructor(relation.target.nodeId, relation.target.graph, model);
          instance._loadFromQuery(relation.target, constructorFunction, fullyLoaded, model, excludeMap, filterFunction);
          this._loadRelationFromQuery(key, instance, relation.nodeId, relation.graph, relation.created, relation.creator);
        }
      }
      this._clearPendingWrites();
      Weaver.publish('node.loaded', this);
      return this;
    }

    _loadAttributeFromQuery(key, value, dataType, attId, graph, created, creator) {
      return this.attribute(key).add(value, {
        dataType,
        node: new Weaver.Node(attId, graph),
        addToPendingWrites: false,
        created,
        creator
      });
    }

    _loadRelationFromQuery(key, instance, relId, graph, created, creator) {
      return this.relation(key).add(instance, {
        node: new Weaver.Node(relId, graph),
        addToPendingWrites: false,
        created,
        creator
      });
    }

    _loadRelationInFromQuery(key, instance, relId, graph, created, creator) {
      var base;
      this.relationIn(key).addIn(instance, {
        node: new Weaver.Node(relId, graph),
        addToPendingWrites: false,
        created,
        creator
      });
      // todo: deprecate this
      if ((base = this.relationsIn)[key] == null) {
        base[key] = new WeaverRelationIn(key);
      }
      return this.relationsIn[key].addSource(instance);
    }

    prettyPrint(opts) {
      return util.prettyPrint(this, opts);
    }

    // Loads current node
    async load() {
      var key, loadedNode, value;
      loadedNode = (await this.constructor.loadFromGraph(this.id(), this.getGraph()));
      for (key in loadedNode) {
        value = loadedNode[key];
        if (!_.isFunction(value)) {
          this[key] = value;
        }
      }
      return this;
    }

    // Node creating for in queries
    static get(nodeId, params = {}) {
      var node;
      if (params.NodeClass == null) {
        params.NodeClass = WeaverNode;
      }
      if (params.upsert == null) {
        params.upsert = false;
      }
      node = new params.NodeClass(nodeId, params.graph, params.upsert);
      if (!params.upsert) {
        node._clearPendingWrites();
      }
      return node;
    }

    static getFromGraph(nodeId, graph, params = {}) {
      params.graph = graph;
      return WeaverNode.get(nodeId, params);
    }

    static firstOrCreate(nodeId, graph, params = {}) {
      if (params.NodeClass == null) {
        params.NodeClass = WeaverNode;
      }
      return WeaverNode.loadFromGraph(nodeId, graph, params).catch(function() {
        return new params.NodeClass(nodeId, graph).save();
      });
    }

    // deprecated
    static firstOrCreateInGraph(nodeId, graph, params = {}) {
      return WeaverNode.firstOrCreate(nodeId, graph);
    }

    isLoaded() {
      return this._loaded;
    }

    // Return id
    id() {
      return this.nodeId;
    }

    changeId(id) {
      var changeNodeIdOperation, oldId, stored;
      stored = this._stored;
      oldId = this.id();
      this._visitPendingWrites(function(op, owner) {
        if (op.action === 'create-node') {
          if (op.id === oldId) {
            op.id = id;
          }
        }
        if (op.sourceId === oldId) {
          return op.sourceId = id;
        }
      });
      if (this._stored) {
        changeNodeIdOperation = new Operation.Node(this).changeNodeId(id);
        this.nodeId = id;
        return this.pendingWrites().push(changeNodeIdOperation);
      }
    }

    changeGraph(newGraph) {
      var changeNodeGraphOperation, j, k, len, len1, op, ref, ref1, results;
      if (this._stored === false) {
        ref = this._pendingWrites;
        results = [];
        for (j = 0, len = ref.length; j < len; j++) {
          op = ref[j];
          if (op.action === 'create-node') {
            op.graph = newGraph;
            results.push(this.graph = newGraph);
          } else {
            results.push(op.sourceGraph = newGraph);
          }
        }
        return results;
      } else {
        ref1 = this._pendingWrites;
        for (k = 0, len1 = ref1.length; k < len1; k++) {
          op = ref1[k];
          op.sourceGraph = newGraph;
        }
        changeNodeGraphOperation = new Operation.Node(this).changeNodeGraph(newGraph);
        this.graph = newGraph;
        return this.pendingWrites().push(changeNodeGraphOperation);
      }
    }

    attributes() {
      var attributes, key;
      attributes = {};
      for (key in this._attributes) {
        attributes[key] = this.get(key);
      }
      return attributes;
    }

    attributeNodeFor(key) {
      var ref, ref1;
      return (ref = this._attributes[key]) != null ? (ref1 = ref.allRecords()) != null ? ref1[0].attNode : void 0 : void 0;
    }

    changeAttributeKey(attr, value) {
      var changeAttributeKeyOperation;
      changeAttributeKeyOperation = new Operation.Node(this).changeAttributeKey(attr, value);
      return this.pendingWrites().push(changeAttributeKeyOperation);
    }

    relations() {
      return this._relations;
    }

    changeRelationKey(relation, value) {
      var changeRelationKeyOperation;
      changeRelationKeyOperation = new Operation.Node(this).changeRelationKey(relation, value);
      return this.pendingWrites().push(changeRelationKeyOperation);
    }

    // deprecated, returns the value of the first attribute
    get(field, params = {}) {
      return this.attribute(field).first(params);
    }

    // deprecated, returns the datatype of the first attribute
    getDataType(field) {
      var record, ref;
      record = (ref = this._attributes[field]) != null ? ref.allRecords()[0] : void 0;
      return record != null ? record.dataType : void 0;
    }

    // deprecated
    set(key, value, params = {}) {
      this.attribute(key).only(value, params);
      return this;
    }

    // deprecaded
    unset(key) {
      return this.attribute(key).removeAll();
    }

    getGraph() {
      return this.graph;
    }

    // Create a new Attribute
    attribute(key, Constructor = Weaver.Attribute) {
      if (key === 'id') {
        throw Error("Attribute 'id' cannot be set or updated");
      }
      if (this._attributes[key] == null) {
        this._attributes[key] = new Constructor(this, key);
        if (this._cache != null) {
          this._attributes[key]._cache = this._cache;
        }
      }
      return this._attributes[key];
    }

    // Create a new Relation
    relation(key, Constructor = Weaver.Relation) {
      if (this._relations[key] == null) {
        this._relations[key] = new Constructor(this, key);
      }
      if (this._cache != null) {
        this._relations[key]._cache = this._cache;
      }
      return this._relations[key];
    }

    // Create a new Relation
    relationIn(key, Constructor = Weaver.Relation) {
      if (this._relationsIn[key] == null) {
        this._relationsIn[key] = new Constructor(this, key, true);
      }
      if (this._cache != null) {
        this._relationsIn[key]._cache = this._cache;
      }
      return this._relationsIn[key];
    }

    applyLabel(...labels) {
      var j, label, len, results;
      this._labels = _.union(this._labels, labels);
      results = [];
      for (j = 0, len = labels.length; j < len; j++) {
        label = labels[j];
        results.push(this.pendingWrites().push(Operation.Node(this).applyLabel(label)));
      }
      return results;
    }

    removeLabel(...labels) {
      var j, label, len, results;
      _.pullAll(this._labels, labels);
      results = [];
      for (j = 0, len = labels.length; j < len; j++) {
        label = labels[j];
        results.push(this.pendingWrites().push(Operation.Node(this).removeLabel(label)));
      }
      return results;
    }

    getLabels() {
      return this._labels;
    }

    peekPendingWrites() {
      return this._collectPendingWrites(void 0, false);
    }

    _traverseNode(modifier, visited = [], representingRecord) {
      var attribute, j, k, key, l, len, len1, len2, len3, m, record, ref, ref1, ref10, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, relation, results;
      if (indexOf.call(visited, this) < 0) {
        // Register to keep track which nodes have been collected to prevent recursive blowup
        visited.push(this);
      }
      modifier(this, representingRecord);
      ref = this._attributes;
      for (key in ref) {
        attribute = ref[key];
        ref1 = attribute.allRecords();
        for (j = 0, len = ref1.length; j < len; j++) {
          record = ref1[j];
          if (ref2 = record.attNode, indexOf.call(visited, ref2) < 0) {
            record.attNode._traverseNode(modifier, visited, record);
          }
        }
      }
      ref3 = this._relations;
      for (key in ref3) {
        relation = ref3[key];
        ref4 = relation.allRecords();
        for (k = 0, len1 = ref4.length; k < len1; k++) {
          record = ref4[k];
          if (ref5 = record.toNode, indexOf.call(visited, ref5) < 0) {
            record.toNode._traverseNode(modifier, visited);
          }
        }
        ref6 = relation.allRecords();
        for (l = 0, len2 = ref6.length; l < len2; l++) {
          record = ref6[l];
          if (ref7 = record.relNode, indexOf.call(visited, ref7) < 0) {
            record.relNode._traverseNode(modifier, visited, record);
          }
        }
      }
      ref8 = this._relationsIn;
      results = [];
      for (key in ref8) {
        relation = ref8[key];
        ref9 = relation.allRecords();
        for (m = 0, len3 = ref9.length; m < len3; m++) {
          record = ref9[m];
          if (ref10 = record.fromNode, indexOf.call(visited, ref10) < 0) {
            record.fromNode._traverseNode(modifier, visited);
          }
        }
        results.push((function() {
          var len4, n, ref11, ref12, results1;
          ref11 = relation.allRecords();
          results1 = [];
          for (n = 0, len4 = ref11.length; n < len4; n++) {
            record = ref11[n];
            if (ref12 = record.relNode, indexOf.call(visited, ref12) < 0) {
              results1.push(record.relNode._traverseNode(modifier, visited, record));
            }
          }
          return results1;
        })());
      }
      return results;
    }

    _visitPendingWrites(modifier, cleanup = false, visited = []) {
      var attribute, j, k, key, l, len, len1, len2, len3, len4, len5, m, n, o, op, record, ref, ref1, ref10, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, relation, results;
      if (indexOf.call(visited, this) < 0) {
        // Register to keep track which nodes have been collected to prevent recursive blowup
        visited.push(this);
      }
      if (this._pendingWrites == null) { // when the node is destroyed
        return;
      }
      ref = this._pendingWrites;
      for (j = 0, len = ref.length; j < len; j++) {
        op = ref[j];
        modifier(op, this);
      }
      if (cleanup) {
        this._pendingWrites = [];
      }
      ref1 = this._attributes;
      for (key in ref1) {
        attribute = ref1[key];
        ref2 = attribute.allRecords();
        for (k = 0, len1 = ref2.length; k < len1; k++) {
          record = ref2[k];
          if (ref3 = record.attNode, indexOf.call(visited, ref3) < 0) {
            record.attNode._visitPendingWrites(modifier, cleanup, visited);
          }
        }
        ref4 = attribute._pendingWrites;
        for (l = 0, len2 = ref4.length; l < len2; l++) {
          op = ref4[l];
          modifier(op, this);
        }
        if (cleanup) {
          attribute._pendingWrites = [];
        }
      }
      ref5 = this._relations;
      results = [];
      for (key in ref5) {
        relation = ref5[key];
        ref6 = relation.allRecords();
        for (m = 0, len3 = ref6.length; m < len3; m++) {
          record = ref6[m];
          if (ref7 = record.toNode, indexOf.call(visited, ref7) < 0) {
            record.toNode._visitPendingWrites(modifier, cleanup, visited);
          }
        }
        ref8 = relation.allRecords();
        for (n = 0, len4 = ref8.length; n < len4; n++) {
          record = ref8[n];
          if (ref9 = record.relNode, indexOf.call(visited, ref9) < 0) {
            record.relNode._visitPendingWrites(modifier, cleanup, visited);
          }
        }
        ref10 = relation._pendingWrites;
        for (o = 0, len5 = ref10.length; o < len5; o++) {
          op = ref10[o];
          modifier(op, this);
        }
        if (cleanup) {
          results.push(relation._pendingWrites = []);
        } else {
          results.push(void 0);
        }
      }
      return results;
    }

    // Go through each relation and recursively add all pendingWrites per relation AND that of the objects
    _collectPendingWrites(collected = [], cleanup = true) {
      var operations;
      operations = [];
      this._visitPendingWrites(function(op, owner) {
        operations.push(op);
        return op.__pendingOpNode = owner;
      }, cleanup);
      return operations;
    }

    // Clear all pendingWrites, used for instance after saving or when loading a node
    _clearPendingWrites() {
      return this._visitPendingWrites(function(op, owner) {}, true);
    }

    _setStored() {
      var attribute, j, k, key, l, len, len1, len2, record, ref, ref1, ref2, ref3, ref4, ref5, relation;
      this._stored = true;
      ref = this._attributes;
      for (key in ref) {
        attribute = ref[key];
        ref1 = attribute.allRecords();
        for (j = 0, len = ref1.length; j < len; j++) {
          record = ref1[j];
          if (!record.attNode._stored) {
            record.attNode._setStored();
          }
        }
      }
      ref2 = this._relations;
      for (key in ref2) {
        relation = ref2[key];
        ref3 = relation.allRecords();
        for (k = 0, len1 = ref3.length; k < len1; k++) {
          record = ref3[k];
          if (!record.toNode._stored) {
            record.toNode._setStored();
          }
          if (!record.relNode._stored) {
            record.relNode._setStored();
          }
        }
      }
      ref4 = this._relationsIn;
      for (key in ref4) {
        relation = ref4[key];
        ref5 = relation.allRecords();
        for (l = 0, len2 = ref5.length; l < len2; l++) {
          record = ref5[l];
          if (!record.fromNode._stored) {
            record.fromNode._setStored();
          }
          if (!record.relNode._stored) {
            record.relNode._setStored();
          }
        }
      }
      return this;
    }

    // Checks whether needs saving
    isDirty() {
      return this._pendingWrites.length !== 0;
    }

    // Save node and all values / relations and relation objects to server
    async save(params) {
      var cm, projectFrozenStatus, writes;
      projectFrozenStatus = (await Weaver.getCoreManager().currentProject.isFrozen());
      if (projectFrozenStatus.status) {
        throw WeaverError(ErrorCodes.OTHER_CAUSE, 'Current project is frozen');
      }
      cm = Weaver.getCoreManager();
      writes = this._collectPendingWrites();
      return cm.enqueue(async() => {
        var e, errorCode, i, j, k, len;
        try {
          await cm.executeOperations((function() {
            var j, len, results;
            results = [];
            for (j = 0, len = writes.length; j < len; j++) {
              i = writes[j];
              results.push(_.omit(i, "__pendingOpNode"));
            }
            return results;
          })(), params);
          for (j = 0, len = writes.length; j < len; j++) {
            i = writes[j];
            Weaver.publish('node.saved', i.__pendingOpNode);
          }
          this._setStored();
          return this;
        } catch (error1) {
          e = error1;
// Restore the pending writes to their originating nodes
// (in reverse order so create-node is done before adding attributes)
          for (k = writes.length - 1; k >= 0; k += -1) {
            i = writes[k];
            i.__pendingOpNode._pendingWrites.unshift(i);
          }
          errorCode = ErrorCodes.OTHER_CAUSE;
          if (e.code != null) {
            errorCode = e.code;
          }
          console.log(e);
          throw WeaverError(errorCode, e.message);
        }
      });
    }

    static async batchSave(array, params) {
      var cm, i, projectFrozenStatus, writes;
      projectFrozenStatus = (await Weaver.getCoreManager().currentProject.isFrozen());
      if (projectFrozenStatus.status) {
        throw WeaverError(ErrorCodes.OTHER_CAUSE, 'Current project is frozen');
      }
      cm = Weaver.getCoreManager();
      writes = [].concat.apply([], (function() {
        var j, len, results;
        results = [];
        for (j = 0, len = array.length; j < len; j++) {
          i = array[j];
          results.push(i._collectPendingWrites());
        }
        return results;
      })());
      return cm.enqueue(async function() {
        var e, errorCode, j, k, len, results;
        try {
          await cm.executeOperations((function() {
            var j, len, results;
            results = [];
            for (j = 0, len = writes.length; j < len; j++) {
              i = writes[j];
              results.push(_.omit(i, '__pendingOpNode'));
            }
            return results;
          })(), params);
          results = [];
          for (j = 0, len = writes.length; j < len; j++) {
            i = writes[j];
            if (i.__pendingOpNode._setStored != null) {
              results.push(i.__pendingOpNode._setStored());
            }
          }
          return results;
        } catch (error1) {
          e = error1;
// Restore the pending writes to their originating nodes
// (in reverse order so create-node is done before adding attributes)
          for (k = writes.length - 1; k >= 0; k += -1) {
            i = writes[k];
            i.__pendingOpNode._pendingWrites.unshift(i);
          }
          errorCode = ErrorCodes.OTHER_CAUSE;
          if (e.code != null) {
            errorCode = e.code;
          }
          throw WeaverError(errorCode, e.message);
        }
      });
    }

    async _destroy(project, unrecoverableRemove = false, propagates = [], propagationDepth = 1, params) {
      var j, len, predicate;
      if (propagationDepth !== 0) {
        for (j = 0, len = propagates.length; j < len; j++) {
          predicate = propagates[j];
          await Promise.mapSeries(this.relation(predicate).all(), async function(node) {
            return (await node.destroy(project, unrecoverableRemove, propagates, --propagationDepth, params));
          });
        }
      }
      return this.pendingWrites().push(Operation.Node(this).removeNode());
    }

    async destroy(project, unrecoverableRemove = false, propagates = [], propagationDepth = 1, params) {
      var key, projectFrozenStatus;
      projectFrozenStatus = (await Weaver.getCoreManager().currentProject.isFrozen());
      if (projectFrozenStatus.status) {
        throw WeaverError(ErrorCodes.OTHER_CAUSE, 'Current project is frozen');
      }
      if (!this.nodeId) {
        return void 0;
      }
      await this._destroy(project, unrecoverableRemove, propagates, propagationDepth, params);
      await this.save(params);
      Weaver.publish('node.destroyed', this.id());
      for (key in this) {
        delete this[key];
      }
      return void 0;
    }

    // Removes nodes in batch
    static async batchDestroy(array, project) {
      var cm, projectFrozenStatus;
      cm = Weaver.getCoreManager();
      projectFrozenStatus = (await cm.currentProject.isFrozen());
      if (projectFrozenStatus.status) {
        throw WeaverError(ErrorCodes.OTHER_CAUSE, 'Current project is frozen');
      }
      return cm.enqueue(async function() {
        var destroyOperations, e, error, errorCode, node;
        if ((array != null) && array.length !== 0) {
          try {
            destroyOperations = (function() {
              var j, len, results;
              results = [];
              for (j = 0, len = array.length; j < len; j++) {
                node = array[j];
                results.push(Operation.Node(node).removeNode());
              }
              return results;
            })();
            try {
              return (await cm.executeOperations(destroyOperations, project));
            } catch (error1) {
              e = error1;
              errorCode = ErrorCodes.OTHER_CAUSE;
              if (e.code != null) {
                errorCode = e.code;
              }
              throw WeaverError(errorCode, e.message);
            }
          } catch (error1) {
            error = error1;
            errorCode = ErrorCodes.OTHER_CAUSE;
            if (error.code != null) {
              errorCode = error.code;
            }
            throw WeaverError(errorCode, error.message);
          }
        } else {
          throw WeaverError(ErrorCodes.OTHER_CAUSE, 'Cannot batch destroy nodes without any node');
        }
      });
    }

    // TODO: Implement
    setACL(acl) {}

    equals(node) {
      return node instanceof WeaverNode && node.id() === this.id() && node.getGraph() === this.getGraph();
    }

    createdAt() {
      return this._createdAt;
    }

    createdBy() {
      return this._createdBy;
    }

    wpath(expr, func, load) {
      return wpath.wpath(this, expr, func, load);
    }

  };

  // Export
  module.exports = WeaverNode;

}).call(this);
